const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

const request = async (endpoint, options = {}) => {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        ...options,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            ...(options.headers || {}),
        },
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
        throw new Error(data.message || "Something went wrong.");
    }

    return data;
};

export const rewardApi = {
    claimReceipt: async ({ invoice_no, phone, amount, target }) => {
        return request("/api/v1/receipt-claims", {
            method: "POST",
            body: JSON.stringify({
                invoice_no,
                phone,
                amount,
                target,
            }),
        });
    },
};